export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-export-csv-0280785638c6e8273c0346a6e6f19135.svg";